// extracted by mini-css-extract-plugin
export default {"check_box_card":"CheckBoxCard_check_box_card__Q6Toh","check_box_card_selected":"CheckBoxCard_check_box_card_selected__5pemf"};